"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var styles_1 = require("styles");
var componentStyle = {
    checked: {
        fontStyle: 'italic',
        fontWeight: 600,
        color: styles_1.FontColor.LightGray,
        textDecoration: 'line-through',
    },
};
var description = 'You can style it as well.';
var code = "import React, { Component } from 'react';\nimport { Checkbox } from 'jsc-react-ui';\n\nconst style = {\n  checked: {\n    fontStyle: 'italic',\n    fontWeight: 600,\n    color: '#b8b8b8',\n    textDecoration: 'line-through',\n  },\n};\n\nclass StylingCheckbox extends Component {\n  constructor(props) {\n    super(props);\n\n    this.state = {\n      checked: false,\n    };\n  }\n\n  render() {\n    const { checked } = this.state;\n\n    return (\n      <Checkbox onChange={this.handleChange}>\n        <span style={checked ? style.checked : {}}>\n          Lunch with my friends\n        </span>\n      </Checkbox>\n    );\n  }\n\n  handleChange = () => {\n    this.setState({ checked: !this.state.checked });\n  }\n}";
var StylingExampleCheckbox = (function (_super) {
    __extends(StylingExampleCheckbox, _super);
    function StylingExampleCheckbox() {
        var _this = _super.call(this) || this;
        _this.handleChange = function () {
            _this.setState({ checked: !_this.state.checked });
        };
        _this.state = {
            checked: false,
        };
        return _this;
    }
    StylingExampleCheckbox.prototype.render = function () {
        var checked = this.state.checked;
        return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
            React.createElement(components_1.Checkbox, { onChange: this.handleChange },
                React.createElement("span", { style: checked ? componentStyle.checked : {} }, "Lunch with my friends"))));
    };
    return StylingExampleCheckbox;
}(react_1.PureComponent));
exports.StylingExampleCheckbox = StylingExampleCheckbox;



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCheckboxPage/StylingExampleCheckbox.tsx
// module id = 651
// module chunks = 0